import React, { Component } from 'react';
import { parseUrl } from 'query-string';
import { connect, ConnectedProps } from 'react-redux';

import { TrackRecosInView } from 'components/productdetail/TrackRecosInView';
import { AppState } from 'types/app';
import Recos from 'components/productdetail/Recos';
import { getRecoSlotData, getRecoSlotKey, shouldRecosUpdate } from 'helpers/RecoUtils';
import { ProductQuickViewReco } from 'components/productdetail/ProductQuickView';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import { areRecosFlattened, RecosState } from 'reducers/recos';
import { JanusData } from 'types/mafia';
import { onEvent } from 'helpers/EventHelpers';
import ProductUtils from 'helpers/ProductUtils';
import { RECOMMENDATION_CTA_CLICK } from 'constants/amethystEnums';

interface Params {
  productId: string;
  colorId?: string;
  seoName?: string;
}
interface OwnProps {
  onRecoClicked: (...args: any) => void;
  params: Params;
  similarProductRecos: RecosState;
  styleId: string;
  heartsData: any; // TODO ts type this when `hearts` are typed
  numberOfGridColumns?: number;
  isHydraMobileTwoRecos?: boolean;
  isHydraProductCardAddItem: boolean;
  titleRef?: React.RefObject<HTMLHeadingElement>;
  isFullMaxWidth?: boolean;
  numberOfVisibleCards?: number;
  isInModal?: boolean;
  trackInViewSourcePage?: string;
}
interface State {
  productIdFromHash: string;
  styleIdFromHash: string;
}

type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = OwnProps & PropsFromRedux;

export class RecosDetail3 extends Component<Props> {
  state: State = {
    productIdFromHash: '',
    styleIdFromHash: ''
  };

  componentDidMount() {
    this.setIdsFromHash();
    onEvent(window, 'popstate', this.setIdsFromHash, this);
  }
  // We don't want this component to re-render when it's either loading, or similarProductRecos haven't changed
  shouldComponentUpdate(nextProps: Props) {
    return shouldRecosUpdate(this.props, nextProps);
  }

  setIdsFromHash = () => {
    const { urlHash } = this.props;
    if (urlHash.includes('#quickview')) {
      const {
        query: { styleId, productId }
      } = parseUrl(urlHash);
      this.setState({
        productIdFromHash: productId,
        styleIdFromHash: styleId
      });
    } else {
      this.setState({
        productIdFromHash: '',
        styleIdFromHash: ''
      });
    }
  };

  render() {
    const {
      similarProductRecos: { janus = {}, lastReceivedRecoKey = '' } = {},
      heartsData,
      numberOfGridColumns,
      onRecoClicked,
      isHydraMobileTwoRecos,
      isHydraProductCardAddItem,
      isFullMaxWidth = false,
      numberOfVisibleCards,
      isInModal,
      trackInViewSourcePage
    } = this.props;

    // If we have recommendations, render the component.
    const janusData = janus[lastReceivedRecoKey] || {};
    let janusRecos: JanusData | undefined;
    if (!areRecosFlattened(janusData)) {
      janusRecos = getRecoSlotData(janusData[getRecoSlotKey(3)]);
    }
    if (janusRecos) {
      const { title, recos } = janusRecos;
      const { productIdFromHash, styleIdFromHash } = this.state;
      const belowImageRenderer = isHydraProductCardAddItem
        ? (props: any) => {
            //TODO ts type this when ProductCard is typed
            const { productId, styleId, index, amethystRecoType } = props;
            const cardData = { ...props };
            // control which modal is open by state set from product and style in hash changes/intial hash
            const open = productId === productIdFromHash && styleId === styleIdFromHash;
            return (
              <ProductQuickViewReco
                cardData={cardData}
                onClick={() => onRecoClicked({ index, productId, amethystRecoType, clickThrough: RECOMMENDATION_CTA_CLICK.QUICK_VIEW })}
                open={open}
                options={{ addToCartText: 'Quick View' }}
              />
            );
          }
        : undefined;

      return (
        <TrackRecosInView
          products={recos}
          impression={{ widgetType: ProductUtils.translateRecoTitleToAmethystWidget(title), numberOfRecommendations: janusRecos?.recos.length }}
          sourcePage={trackInViewSourcePage}
        >
          <Recos
            id="alsoSimilar"
            recoType="subRecos"
            title={title}
            recos={recos}
            onRecoClicked={onRecoClicked}
            heartsData={heartsData}
            numberOfGridColumns={numberOfGridColumns}
            belowImageRenderer={belowImageRenderer}
            isFullMaxWidth={isFullMaxWidth}
            isHydraMobileTwoRecos={isHydraMobileTwoRecos}
            numberOfVisibleCards={numberOfVisibleCards}
            isInModal={isInModal}
          />
        </TrackRecosInView>
      );
    }
    return null;
  }
}

const mapStateToProps = (state: AppState) => {
  const {
    router: {
      location: { hash = '' }
    }
  } = state;
  return { urlHash: hash };
};
const connector = connect(mapStateToProps, {});
export default withErrorBoundary('RecosDetail3', connector(RecosDetail3));
